import Dialog from '@mui/material/Dialog';
import React from 'react';

import { ContactPropertiesDto } from '@/api/generated';
import ContactsCreateView from '@/views/contactsCreate/ContactsCreate.view.tsx';

type Props = {
  onClose: () => void;
  onCreated: (contactName: string) => void;
};

export const ProcessAddContactDialogCreateContactDialog: React.FC<Props> = props => {
  const { onClose, onCreated } = props;

  const handlePostCreateAction = (contact: ContactPropertiesDto) => {
    onCreated(contact.displayName);
    onClose();
  };

  return (
    <Dialog open={true} sx={{ '& .MuiDialog-paper': { minWidth: '90vw' } }}>
      <ContactsCreateView onCancel={onClose} onPostCreateAction={handlePostCreateAction} />
    </Dialog>
  );
};
